<template>
  <div class="space-y-1 p-2">
    <div 
      v-for="i in count" 
      :key="i"
      class="flex items-center gap-3 p-3 rounded-lg animate-pulse"
    >
      <!-- Avatar Skeleton -->
      <div class="flex-shrink-0">
        <div class="h-12 w-12 bg-gray-200 rounded-full"></div>
      </div>

      <!-- Contact Info Skeleton -->
      <div class="flex-1 min-w-0 space-y-2">
        <div class="flex items-center justify-between">
          <div class="h-4 bg-gray-200 rounded w-32"></div>
          <div class="h-3 bg-gray-200 rounded w-12"></div>
        </div>
        <div class="h-3 bg-gray-200 rounded w-48"></div>
      </div>

      <!-- Unread Badge Skeleton (random appearance) -->
      <div v-if="i % 3 === 0" class="flex-shrink-0">
        <div class="w-5 h-5 bg-gray-200 rounded-full"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  count?: number
}>()
</script>
